import React from 'react';
import { Formik, Form } from 'formik';
import { Link } from 'gatsby';
import classnames from 'classnames';

import * as styles from './style.module.scss';
import validationSchema from './validationSchema';
import Input from 'components/UI/InputFormik';
import Checkbox from 'components/UI/Checkbox';
import DropdownForm from 'components/UI/DropdownForm';
import Button from 'components/UI/Button';
import Icon from 'components/UI/Icon';

const OPTIONS = [
  {
    title: 'option 1',
    value: 'val_1',
  },
  {
    title: 'option 2',
    value: 'val_2',
  },
  {
    title: 'option 3',
    value: 'val_3',
  },
];

const FormElem = ({ onSubmit }) => {
  return (
    <Formik
      initialValues={{
        topic: '',
        name: '',
        companyName: '',
        phone: '',
        email: '',
        accept: false,
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          alert(JSON.stringify(values, null, 2));
          setSubmitting(false);
          onSubmit(values);
        }, 400);
      }}
    >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form className={styles.form} noValidate>
            <ul className={styles.form_inputs}>
              <li>
                <DropdownForm
                  list={OPTIONS}
                  name="topic"
                  placeholder="Pickup a topic for your message"
                  error={errors.topic}
                  onSelect={(data) => setFieldValue('topic', data.value)}
                />
              </li>
              <li>
                <Input name="name" type="text" placeholder="Name" />
              </li>
              <li>
                <Input
                  name="companyName"
                  type="text"
                  placeholder="Company name"
                />
              </li>
              <li>
                <Input name="phone" type="tel" placeholder="Phone" />
              </li>
              <li>
                <Input name="email" type="email" placeholder="Email" />
              </li>
            </ul>

            <div className={styles.form_submit}>
              <Checkbox name="accept">
                I agree with
                <Link to="#" className={'cr-link cr-main'}>
                  Terms & Conditions.
                </Link>
              </Checkbox>
            </div>

            <Button
              type="submit"
              className={classnames(
                'cr-btn--icon cr-btn--large cr-btn--icon-red-bg',
                styles.form_submit_btn
              )}
            >
              Submit
              <Icon name="corner-arrow-small-bold" />
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FormElem;
